import React, {Component} from 'react'
import {Tree, Tag, Empty, Space, Select, Form, notification} from 'antd'
import {getMallRoleList, saveUserRole} from "../../request";

import './index.less'
import {apiGetRequest} from "../../http/http";
export default class SysUserRight extends Component {
    formRef = React.createRef();
    state = {
        rolesAllList: [],
        collapsed: false
    }
    initRoleList = () => {
        getMallRoleList({
            roleName: '',
            currentPage: 1,
            pageSize: 5000
        }).then(res => {
            this.setState({
                rolesAllList: res.list
            })
        })
    }
    resetForm = (roles)=>{
        this.formRef.current.setFieldsValue({roles:roles||[]})
    }
    handleSelectRole = (value)=>{
        saveUserRole({roleIds: value.roles.join(','),userId: this.props.userInfo.userId}).
        then(res=>{
            notification.success({
                message: '操作成功',
            });
            this.props.resLoadRight()

        })
    }
    handleRight = (node)=>{
        apiGetRequest('lechun-baseservice/user/saveUserPrivateResources',{
            userId: this.props.userInfo.userId,
            resourceId: node.resourceId
        }).then(res=> {
            notification.success({
                message: '申请成功，请稍后刷新查看',
            });
        })
    }
    componentDidMount() {
        this.initRoleList()
    }

    render() {
        const {rolesAllList} = this.state;
        return (
            <div className={'sys-user-right'}>
                <div className="task-tag">
                    <span>所属角色</span>
                </div>
                <div className={'task-tag-content'}>
                    <Form ref={this.formRef} initialValues={{roles: this.props.rolesList}}
                          onValuesChange={this.handleSelectRole}
                    >
                        <Form.Item name="roles">
                            <Select
                                mode="multiple"
                                allowClear
                                style={{width: '100%'}}
                                showSearch
                                placeholder="请选择"
                                fieldNames={{label: 'roleName', value: 'roleId'}}
                                filterOption={(input, option) =>
                                    (option?.roleName ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                tagRender={(props) => {
                                    const {label, value, closable, onClose} = props;
                                    return (
                                        <Tag style={{margin: 5}} color={'pink'} closable={closable}
                                             onClose={onClose}>{label}</Tag>
                                    )
                                }}
                                options={rolesAllList}
                            />
                        </Form.Item>
                    </Form>
                </div>
                <div className="task-tag">
                    <span>页面权限</span>
                </div>
                <div className={'task-tag-content'}>
                    <Space className={'sys-user-right-tag-space'}>
                        <div>页面菜单</div>
                        <div>角色权限</div>
                    </Space>
                    {
                        this.props.resourcesList.length > 0 ?
                            <Tree.DirectoryTree
                                defaultExpandAll={ true}
                                treeData={this.props.resourcesList}
                                fieldNames={{title: 'resourceName', key: 'resourceId', children: 'children'}}
                                titleRender={node => {
                                    return (
                                        <Space>
                                        <span>
                                            {node.resourceName}
                                            {
                                                node.isLeaf && node.hasRight != 1 ?
                                                    <span onClick={()=>this.handleRight(node)} style={{
                                                        color: '#1890ff',
                                                        cursor: 'pointer',
                                                        marginLeft: 10,
                                                        fontSize:10
                                                    }}>申请权限</span> : ''
                                            }

                                        </span>

                                            {
                                                node.isLeaf ?
                                                    <span style={{color: '#666666'}}>{node.roleNames}</span>
                                                    : ''
                                            }


                                        </Space>
                                    )
                                }}
                            /> :
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>

                    }
                </div>


            </div>
        )
    }
}